{
	"acne": "Acne",
	"alignment": "Alignment",
	"blemishRemoval": "Blemish Removal",
	"blush": "Blush",
	"cool": "Cool",
	"couldNotDetectPeople": "Could not detect people",
	"copper": "Copper",
	"darkCircles": "Dark Circles",
	"enhancement": "Enhancement",
	"eyeBags": "Eye Bags",
	"eyeWrinkles": "Eye Wrinkles",
	"faces": "Faces",
	"faceShine": "Face Shine",
	"flawRemoval": "Flaw Removal",
	"freckles": "Freckles",
	"glassesGlare": "Glasses Glare",
	"more": "More",
	"mocha": "Mocha",
	"noSkinTone": "No skin tone",
	"noPeopleDetected": "No people detected",
	"peach": "Peach",
	"peoplePanel": "People Panel",
	"redEye": "Red Eye",
	"rose": "Rose",
	"selectASkinToneTo": "Select a skin tone to apply",
	"showMoreFaces": "Show more faces",
	"skinRetouching": "Skin Retouching",
	"skinTone": "Skin Tone",
	"sculpt": "Sculpt",
	"smoothing": "Smoothing",
	"smileLine": "Smile Line",
	"strength": "Strength",
	"strayHair": "Stray Hair",
	"teeth": "Teeth",
	"texture": "Texture",
	"unifyTone": "Unify Tone",
	"white": "White",
	"whitening": "Whitening",
	"eyes": "Eyes"
}
